import { Component, Input, OnInit } from "@angular/core";

@Component({
    selector: "a[love-it-tab]",
    templateUrl: "./tab.component.html",
    styleUrls: ["./tab.component.scss"],
    standalone: false
})
export class TabComponent implements OnInit {
  @Input() label: string;
  @Input() invalid: boolean = false;
  @Input() warning: boolean = false;
  @Input() icon: string;

  constructor() {}

  ngOnInit(): void {}
}
